import type { HTMLAttributes } from "react";
import { useT } from "../i18n";
import { cn } from "../lib/cn";

export function Skeleton({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div aria-hidden className={cn("animate-skeleton rounded-sm bg-surface-active", className)} {...rest} />;
}

/** A list of rows, for any list while it loads. */
export function SkeletonList({ rows = 4 }: { rows?: number }) {
  const t = useT();
  return (
    <div role="status" aria-label={t("common.loading")} className="flex flex-col gap-2.5">
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className="rounded-lg border border-border bg-surface p-4">
          <Skeleton className="h-4 w-2/5" />
          <Skeleton className="mt-2.5 h-3 w-3/4" />
        </div>
      ))}
    </div>
  );
}
